import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from '@xstore/shared/ui';

import { useAuth } from '../providers/auth-provider';

export function AuthGuard() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
